import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';
import { getReports, type ReportsQuery } from '@/services/api/reports';

export const REPORTS_QUERY_KEY = ['reports'] as const;

export const reportsQueryOptions = (query: ReportsQuery) =>
  queryOptions({
    queryKey: [...REPORTS_QUERY_KEY, query.type, query.from, query.to],
    queryFn: () => getReports(query),
    // Long ranges are slow (one S3 LIST per day server-side) — keep the previous
    // result set on screen while a re-search with new params is in flight.
    placeholderData: keepPreviousData,
  });

export const useReports = (query: ReportsQuery) => useQuery(reportsQueryOptions(query));
